// src/resources/verifiedCars.js
import React from 'react';
import { List, Datagrid, TextField, ReferenceField, TextInput } from 'react-admin';
import ResponsiveDatagrid from '../components/ResponsiveDatagrid';

const carFilters = [
    <TextInput source="q" label="Search by Owner or Plate" alwaysOn />,
];

export const VerifiedCarList = (props) => (
    <List {...props} filters={carFilters} title="Verified Cars">
        <ResponsiveDatagrid>
            {/* --- THIS IS THE FIX --- */}
            {/* The reference should be "users", not "verified-users" */}
            <ReferenceField source="userId" reference="users" label="Owner">
                <TextField source="name" />
            </ReferenceField>
            <TextField source="brand" />
            <TextField source="model" />
            <TextField source="year" />
            <TextField source="plate" />
            <TextField source="color" />
        </ResponsiveDatagrid>
    </List>
);